package com.exura.pages.planCreator.components.seriesViews.sections

import androidx.compose.runtime.*
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorInputMode
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorIntegerInput
import com.exura.ui.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

@Composable
internal fun QuestionDurationSection(
    duration: Int,
    onDurationChange: (Int) -> Unit,
    mode: PlanCreatorInputMode,
    enabled: Boolean = true,
) = EditViewSection(
    enabled = enabled,
    title = "Jak długo chcesz wyświetlać pytanie?"
) {
    Row(
        horizontalArrangement = Arrangement.spacedBy(12.px),
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier.fillMaxWidth()
    ) {
        SpanText("Przez")

        PlanCreatorIntegerInput(
            value = duration,
            onValueChange = onDurationChange,
            mode = mode,
            modifier = Modifier.width(80.px),
            textStyle = TextStyles.medium16,
            minValue = 1,
            placeholder = "1"
        )

        SpanText(if (duration == 1) "dzień" else "dni")
    }
}
